import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { forkJoin, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CatEmployeeJobModel } from 'src/app/model/cat-employee-job.model';
import { CatJobPositionBIModel } from 'src/app/model/cat-job-position-bi.model';
import { CatEmployeeJobService } from 'src/app/services/cat-employee-job.service';
import { CatJobPositionBiService } from 'src/oldApp/services/cat-job-position-bi.service';
import { CreatorService } from 'src/app/services/creator.service';
import { ModalJobPositionBiComponent } from 'src/oldApp/shared/modal-job-position-bi/modal-job-position-bi.component';

@Component({
  selector: 'app-cat-job-position-bi',
  templateUrl: './cat-job-position-bi.component.html',
  styleUrls: ['./cat-job-position-bi.component.css']
})
export class CatJobPositionBiComponent implements OnInit {
  // estado pagina
  public page:string='CatJobPositionBi';
  public viewStatus=0;  // -1:nada, 0:spinner, 1:tabla
  public positions:CatJobPositionBIModel[]=[];

  // catalogos
  public employeeJobCatalog:CatEmployeeJobModel[];

  // opciones datatables
  dtOptions={
    order:[],
    responsive:true,
    columnDefs: [
      { responsivePriority: 1, width:100, targets: -1 }
    ],
    bLengthChange: true,
    searching :true,
    dom:'<"row"<"col"l><"col"<"text-center"B>><"col"f>><"row"<"col"t>><"row"<"col"i><"col"p>>',
    buttons: ['csv', 'excel'],
    autoWidth:false,
    // pagingType: 'full_numbers',
    paging:true,
    pageLength: 100,
    language: {
      processing: 'Procesando...',
      search: 'Buscar:',
      lengthMenu: 'Mostrar _MENU_ elementos',
      info: 'Mostrando del _START_ al _END_ de _TOTAL_ elementos',
      infoEmpty: 'Mostrando ningún elemento.',
      infoFiltered: '(filtrado _MAX_ elementos total)',
      infoPostFix: '',
      loadingRecords: 'Cargando registros...',
      zeroRecords: 'No se encontraron registros',
      emptyTable: 'No hay datos disponibles en la tabla',
      paginate: {
        first: 'Primero',
        previous: 'Anterior',
        next: 'Siguiente',
        last: 'Último'
      },
      aria: {
        sortAscending: ': Activar para ordenar la tabla en orden ascendente',
        sortDescending: ': Activar para ordenar la tabla en orden descendente'
      },
      // dom: 'Bfrtip',
      buttons: [
        'excel'
      ]
    }
  };

  /////////////////
  constructor(
    private creator:CreatorService,
    private modalService:NgbModal,
    private jobPositionBiService:CatJobPositionBiService,
    private employeeJobService:CatEmployeeJobService,
    private toastr:ToastrService
  ) { }
  ngOnInit() {
    this.getCatalogs();
  }

  // 
  add=()=> {
    let position=this.creator.newCatGoalRegion();
    let modalRef=this.modalService.open(ModalJobPositionBiComponent, {centered:true, backdrop:'static', keyboard:false});
    modalRef.componentInstance.position={...position};
    modalRef.componentInstance.page=this.page;
    modalRef.componentInstance.mode='create';
    modalRef.result.then(
      data=> console.log(data),
      reason=> {
        console.log(reason);
        this.viewStatus=0;
        this.getCatalogs();
      }
    );
  }
  edit=(position:CatJobPositionBIModel)=> {
    let modalRef=this.modalService.open(ModalJobPositionBiComponent, {centered:true, backdrop:'static', keyboard:false});
    modalRef.componentInstance.position={...position};
    modalRef.componentInstance.page=this.page;
    modalRef.componentInstance.mode='edit';
    modalRef.result.then(
      data=> console.log(data),
      reason=> {
        console.log(reason);
        this.viewStatus=0;
        this.getCatalogs();
      }
    );
  }

  // HELPERS
  jobDescription=position=> this.employeeJobCatalog.find(j=> j.employeeJobId===position.jobPositionId).description;

  // INFO
  getCatalogs=()=> {
    forkJoin(
      this.jobPositionBiService.getAll(),
      this.employeeJobService.getAll()
    )
    .pipe(
      tap(([positionResp, jobResp]:[any, any])=> {
        this.positions=positionResp.data;
        this.employeeJobCatalog=jobResp.data;
        this.viewStatus=1;
      }),
      catchError(error=> {
        this.viewStatus=-1;
        return of(this.toastr.error('Ocurrió un error al leer catálogos.'));
      })
    )
    .subscribe();
  }
}
